import React, { useState, useEffect, useRef } from "react";
import { fabric } from "fabric";

import { Filters } from "../filters";

const THUMBNAIL_SIZE = {
  width: 50,
  height: 50,
};
const Thumbnail = (props) => {
  let { image, filter } = props;

  const [canvas, setCanvas] = useState(null);

  const canvasRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) {
      return;
    }

    const thumbnailCanvas = new fabric.StaticCanvas(
      canvasRef.current,
      THUMBNAIL_SIZE
    );

    // thumbnailCanvas.renderAll();

    setCanvas(thumbnailCanvas);
  }, []);

  useEffect(() => {
    if (!canvas) {
      return;
    }

    fabric.Image.fromURL(
      image,
      (oImg) => {
        oImg.lockMovementX = true;
        oImg.lockMovementY = true;
        oImg.selectable = false;

        let left = 0;
        let top = 0;
        if (oImg.width < oImg.height) {
          oImg.scaleToWidth(THUMBNAIL_SIZE.width);
          let scale = THUMBNAIL_SIZE.width / oImg.width;
          let difHeight = THUMBNAIL_SIZE.height - oImg.height * scale;
          top = difHeight / 2;
        } else {
          oImg.scaleToHeight(THUMBNAIL_SIZE.height);
          let scale = THUMBNAIL_SIZE.height / oImg.height;
          let difWidth = THUMBNAIL_SIZE.width - oImg.width * scale;
          left = difWidth / 2;
        }

        oImg.set({
          left,
          top,
        });

        let fabricFilter = Filters[filter.type];
        fabricFilter.intensity = 1;

        oImg.filters = [fabricFilter];
        oImg.applyFilters();

        canvas.add(oImg);
        canvas.renderAll();
      },
      { crossOrigin: "anonymous" }
    );

    return () => {
      if (canvas) {
        canvas.dispose();
      }
    };
    // canvas.requestRenderAll();
  }, [canvas, image, filter]);

  return (
    <div>
      <canvas ref={canvasRef} />
    </div>
  );
};

export default Thumbnail;
